
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import { MOTIVO_CANCELAMENTO, MultaCancelamento, SolicitacaoCancelamentoGarantia } from 'src/app/model/solicitacao-cancelamento-garantia.model';
import { Estado } from '../../model/estado.model';
import { FgiBackEndService } from '../fgi-back-end.service';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { OperacaoGarantida } from 'src/app/model/operacao-garantida.model';

@Injectable({
  providedIn: 'root'
})
export class SolicitacaoCancelamentoGarantiaService extends FgiBackEndService<SolicitacaoCancelamentoGarantia>{
  private operacao:OperacaoGarantida = null;
  setOperacaoGarantida(model: OperacaoGarantida) {
    this.operacao = model;
  }

  getOperacaoGarantida(){
    return this.operacao;
  }


  // @Override
  getNewEntity() {
    const model: SolicitacaoCancelamentoGarantia = new SolicitacaoCancelamentoGarantia();
    model.ideMotivoSolicitacaoCancelamento = MOTIVO_CANCELAMENTO[0].codigo;
    model.dataEnvio = new Date();

    return model;
  }

  // @Override
  protected getResourceURL(): string {
    return 'front/solicitacoes-cancelamento';
  }

  salvarSolicitacaoCancelamento(solicitacaoCancelamento: SolicitacaoCancelamentoGarantia, apenasValidar: boolean): Observable<any> {
    const options: any = blockUi();
    options.params.apenasValidacao = apenasValidar;
    return this.http.post(`${this.BASE_URL}/`, solicitacaoCancelamento, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }

  aprovarSolicitacaoCancelamento(idSolicitacaoCancelamento: number, multa: MultaCancelamento): Observable<any> {
    const options: any = blockUi();

    console.log("aprovando...");

    return this.http.post(`${this.BASE_URL}/${idSolicitacaoCancelamento}/aprovar`, multa, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }

  reprovarSolicitacaoCancelamento(idSolicitacaoCancelamento: number, motivoReprovacao: string): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/${idSolicitacaoCancelamento}/reprovar`, motivoReprovacao, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }

  reverterSolicitacaoCancelamento(idSolicitacaoCancelamento: number, motivoReversao: string): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/${idSolicitacaoCancelamento}/reverter`, motivoReversao, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }

  // nao tem no BaseEntityService pra fazer override
  getSolicitacaoCancelamento(id): Observable<SolicitacaoCancelamentoGarantia> {
    return this.http.get(`${this.BASE_URL}/${id}`).pipe(
      catchError((e) => this.handleError(e))) as Observable<SolicitacaoCancelamentoGarantia>;
  }

  // nao tem no BaseEntityService pra fazer override
  getSolicitacoesCancelamento(params?: any): any {
    return this.http.get(`${this.BASE_URL}`, { params: params }).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<SolicitacaoCancelamentoGarantia>>;
  }

  // nao tem no BaseEntityService pra fazer override
  getEstadosSolicitacoesCancelamento(params?: any): any {
    return this.http.get(`${this.BASE_URL}/estados`, { params: params }).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<Estado>>;
  }
}
